module.exports = __webpack_public_path__ + "img/facebook.09b461d3.png";